import { setObjects } from '../helpers';

const initialState = () => ({
    currentId: null,
    storage: {
        /*id: {
            id: 0,
            image: 'http://placehold.it/150?text=opdracht',
            title: 'Voordoen, nadoen',
            intro: 'Wist je dat voor het kleuren van verf vroeger pigmenten van planten en dieren gebruikt werden? Zo werd Sepia (een bruin-grijze kleur) van de inkt van een zeekat gemaakt. ',
            started: date
            finished: date
            steps: [
                { title: 'Stap 1', content: 'Dit is de eerste stap', submissions: [] },
                { title: 'Stap 2', content: 'Dit is stap twee!', submissions: [] },
                { title: 'Stap 3', content: 'Dit is stap drie!', submissions: [] }
            ]
        },*/
    },
    reflectiontips: { }
})

const mutations = {
    SET_CURRENT_ASSIGNMENT (state, assignment) {
        state.currentId = assignment.id;
    },
    RESET_CURRENT_ASSIGNMENT (state) {
        state.currentId = null
    },
    ADD_ASSIGNMENTS (state, assignments) {
        setObjects(assignments, state.storage, { progress: [], goals: [], remarks: [], compliments: [], predecessors: [], successors: [] })
    },
    ADD_PROGRESS_TO_ASSIGNMENT (state, assignmentId, progressId) {
        state.storage[assignmentId].progress.push(progressId)
    },
    ADD_REFLECTIONTIPS (state, reflectiontips) {
        setObjects(reflectiontips, state.reflectiontips)
    },
}

export default {
    initialState,
    state: initialState(),
    mutations
}



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/assignments.js